import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Select,
    TextField
} from '@material-ui/core';
import * as moment from 'moment';
import * as React from 'react';

interface NotInterestedRightNowState {
    optOutDuration: number;
    optOutNote: string;
}

interface OwnProps {
    show: boolean;
    requestClose: () => void;
    onDisqualify: (note: string, optOutUntil: number) => void;
}

type NotInterestedRightNowProps = OwnProps;

export class NotInterestedRightNow extends React.Component<NotInterestedRightNowProps, NotInterestedRightNowState> {
    constructor(props: NotInterestedRightNowProps) {
        super(props);
        this.state = {
            optOutDuration: 2,
            optOutNote: ''
        };
    }

    editNoteValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ optOutNote: event.target.value });
    };

    handleOptOut = () => {
        const didNotSpecifyDuration = 2;
        const optOutUntil = this.state.optOutDuration > 0 ? this.state.optOutDuration : didNotSpecifyDuration;
        this.props.onDisqualify(this.state.optOutNote, moment().add(optOutUntil, 'months').utc().valueOf());
    };

    handleOptOutSelectDuration = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ optOutDuration: event.target.value as number });
    };

    getDisplayText = (months: number) => {
        return `in ${moment().add(months, 'months').format('MMMM')}`;
    };

    render() {
        return (
            <Dialog className="opt-out-dialog" open={this.props.show} onClose={this.props.requestClose}>
                <DialogTitle>Not Right Time</DialogTitle>
                <DialogContent>
                    <div className="not-right-time-dropdown-line">
                        <span className="dropdown-label">Candidate wants to be contacted in:</span>
                        <Select value={this.state.optOutDuration} onChange={this.handleOptOutSelectDuration}>
                            {/* tslint:disable:no-magic-numbers */}
                            <MenuItem value={1}>{this.getDisplayText(1)}</MenuItem>
                            <MenuItem value={2}>{this.getDisplayText(2)}</MenuItem>
                            <MenuItem value={3}>{this.getDisplayText(3)}</MenuItem>
                            <MenuItem value={-1}>(Did not specify)</MenuItem>
                            {/* tslint:enable:no-magic-numbers */}
                        </Select>
                    </div>
                    <TextField placeholder="Add Note" onChange={this.editNoteValue} multiline={true} />
                    <div className="opt-out-note">This will remove the candidate from ALL current email sequences.</div>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="text" onClick={this.props.requestClose}>
                        Cancel
                    </Button>
                    <Button color="primary" variant="text" onClick={this.handleOptOut}>
                        Pause
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
